/* Product V5 — Storytelling Section Extension
   Design-Overhaul 2026 | Premium Editorial Quality
   - Staggered Reveal Animationen
   - Sticky Image Switcher mit Crossfade
   - Parallax DISABLED — Bild bleibt statisch (User-Feedback SHO-116)
   Budget: <4KB | No dependencies */
(function(){
  'use strict';

  var section = document.querySelector('.pv5-storytelling');
  if (!section) return;

  /* prefers-reduced-motion: sofort alles sichtbar machen */
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reducedMotion) {
    section.querySelectorAll('.reveal').forEach(function(el){
      el.classList.add('visible');
    });
    return;
  }

  /* =====================================================
     STAGGERED REVEAL — Intersection Observer
     Medienelement sofort, Text-Elemente mit Stagger
     ===================================================== */
  var revealObs = new IntersectionObserver(function(entries){
    entries.forEach(function(entry){
      if (!entry.isIntersecting) return;
      var el = entry.target;
      el.classList.add('visible');
      revealObs.unobserve(el);
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });

  section.querySelectorAll('.reveal').forEach(function(el){
    revealObs.observe(el);
  });

  /* =====================================================
     STICKY IMAGE SWITCHER — nur bei sticky-split Layout
     Crossfade beim Beat-Wechsel (opacity 0.4 → 1)
     ===================================================== */
  var layout = section.getAttribute('data-layout');
  if (layout === 'sticky-split' && window.innerWidth >= 990) {
    var beats = section.querySelectorAll('.pv5-story-beat');
    if (beats.length >= 2) {

      var imageObs = new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          if (!entry.isIntersecting) return;
          var beat = entry.target;
          var stickyImg = beat.querySelector('.pv5-story-beat__image');
          if (!stickyImg) return;

          /* Crossfade: kurz ausblenden, dann einblenden */
          stickyImg.style.transition = 'opacity 0.4s ease';
          stickyImg.style.opacity = '0.3';
          requestAnimationFrame(function(){
            requestAnimationFrame(function(){
              stickyImg.style.opacity = '1';
            });
          });
        });
      }, { threshold: 0.4, rootMargin: '-10% 0px -10% 0px' });

      beats.forEach(function(beat){ imageObs.observe(beat); });
    }
  }

  /* PARALLAX entfernt — User-Feedback SHO-116: Bild soll statisch bleiben beim Scrollen */

})();
